import FileUploadController from '@controllers/portal/components/file_upload_controller';

export default class extends FileUploadController {
  static targets = ['file', 'list', 'uploadButton']
  currTarget = 0;

  connect() {
    this.checkUploadLimit();
  }
  
  handleFileInputChange() {
    const isValid = super.canUploadFile()
    if (!isValid) return
      
    Array.from(this.fileTarget.files).forEach((file) => {
      this.addVariantImage(file)
    });
      
    this.fileTarget.value = "";
    this.checkUploadLimit();
  }
  
  addVariantImage(file) {
    if (this.checkUploadLimit()) return;
    const template = document.getElementById('variant-image-template');
    const variantImageName = file.name;
    const variantImageUrl = URL.createObjectURL(file);
    const clone = template.content.cloneNode(true);

    // Upload count sets position for the new image. Add 1 for 1 based indexing.
    const uploadCount = this.listTarget.querySelectorAll('[data-variant-image-row]').length + 1;

    // set preview text and image
    clone.querySelector('[data-field="name"]').textContent = variantImageName;
    clone.querySelector('[data-field="icon"]').src = variantImageUrl;

    // update the hidden file input for form submission
    const fileInput = clone.querySelector('input[data-field="file"]');
    fileInput.name = fileInput.name.replace('%pos%', uploadCount);

    // Add hidden id input to keep data consistent for existing images
    const idInput = clone.querySelector('input[data-field="id"]');
    idInput.name = idInput.name.replace('%pos%', uploadCount);

    // assign the uploaded file to the hidden input
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    fileInput.files = dataTransfer.files;

    const row = clone.querySelector('[data-variant-image-row]');
    row.appendChild(idInput);
    row.appendChild(fileInput);

    this.listTarget.appendChild(clone);
    this.clearError();
  }
  
  remove(e) {
    e.preventDefault();
    const row = e.target.closest("[data-variant-image-row]");
    this.updatePositions(row);
    if (row) row.remove();
    
    this.checkUploadLimit();
  }
  
  markForDeletion(e) {
    e.preventDefault();
    const row = e.target.closest("[data-variant-image-row]");
    const destroyInput = row.querySelector('[data-destroy-field]')
    destroyInput.value = '1';

    row.classList.add('hidden');
    this.checkUploadLimit();
  }

  updatePositions(row) {
    while (row.nextElementSibling) {
      row = row.nextElementSibling;
      const inputName = row.querySelector('input').name;
      const inputIndex = parseInt(inputName.match(/index_(\d+)/)[1], 10);
      row.querySelectorAll('input').forEach(input => {
        input.name = input.name.replace(`index_${inputIndex}`, `index_${inputIndex - 1}`);
      });
    }
  }

  checkUploadCount() {
    return this.listTarget.querySelectorAll('[data-variant-image-row]:not(.hidden)').length;
  }

  checkUploadLimit() {
    const count = this.checkUploadCount();
    const limitReached = count >= 4;
    this.fileTarget.disabled = limitReached
    this.uploadButtonTarget.classList.toggle('is-disabled', limitReached);
    return limitReached;
  }

  setError(message) {
    this.errorMessageTarget.textContent = message;
    this.errorMessageTarget.classList.remove('hidden');
    // Add error class dynamically to prevent scrollTo issues from form controller
    this.errorMessageTarget.classList.add('error');
  }

  clearError() {
    this.errorMessageTarget.textContent = '';
    this.errorMessageTarget.classList.add('hidden');
    // Remove error class dynamically to prevent scrollTo issues from form controller
    this.errorMessageTarget.classList.remove('error');
  }

  validate() {
    const count = this.checkUploadCount();
    if (count === 0) {
      this.setError('At least one image is required.');
      return false;
    }
    this.clearError();
    return true;
  }
}
